<template>
<div class="chapter">
<div class="inner_page">
<p class="p10">For my amazing husband, a word I never thought I would use, a man I never thought I’d find.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?339f830a